import {
  LuActivity,
  LuBarChartBig,
  LuShapes,
  LuSquareSlash,
  LuStethoscope,
  LuStickyNote,
  LuTablets,
  LuTrendingUp,
  LuUserSquare2,
  LuWarehouse,
  LuWebhook,
} from "react-icons/lu";
import { MenuType } from "../types/menu.type";

const HEADER_HEIGHT: string = "60px";
const SIDEBAR_MINWIDTH: string = "72px";
const SIDEBAR_MAXWIDTH: string = "260px";

const MENUS: MenuType[] = [
  {
    subheader: "Dữ liệu đầu vào",
    items: [
      { text: "Thuốc", Icon: LuShapes, path: "/list/cr_thuoc" },
      { text: "Vật tư y tế", Icon: LuStethoscope, path: "/list/cr_vtyt" },
      { text: "Hóa chất", Icon: LuTablets, path: "/list/cr_hc" },
    ],
  },
  {
    subheader: "Dữ liệu đầu ra",
    items: [
      {
        text: "BC tổng hợp KQTT",
        path: "/group/cr_thuoc",
        Icon: LuBarChartBig,
      },
    ],
  },
  {
    subheader: "Quản lý trúng thầu",
    items: [
      {
        text: "KQTT thuốc",
        path: "/list/kqtt_thuoc",
        Icon: LuShapes,
      },
      {
        text: "KQTT vật tư, hóa chất",
        path: "/list/cr_tt_vthc",
        Icon: LuTablets,
      },
      {
        text: "Nhập kho TT",
        path: "/list/nk_tt",
        Icon: LuStickyNote,
      },
      {
        text: "Xuất kho TT",
        path: "/list/xk_tt",
        Icon: LuSquareSlash,
      },
      {
        text: "Báo cáo thực hiện TT",
        path: "/list/bc_tt",
        Icon: LuTrendingUp,
      },
    ],
  },
  {
    subheader: "Quản lý đối tượng",
    items: [
      { text: "Chủ đầu tư", Icon: LuUserSquare2, path: "/list/customer" },
    ],
  },
  {
    subheader: "Danh mục chung",
    items: [
      { text: "Nhóm thuốc", Icon: LuTablets, path: "/list/cr_nhomthuoc" },
      { text: "Hoạt chất", Icon: LuActivity, path: "/list/cr_hoatchat" },
      { text: "Đường dùng", Icon: LuWebhook, path: "/list/cr_duongdung" },
      { text: "Nước sản xuất", Icon: LuWarehouse, path: "/list/cr_nsx" },
    ],
  },
];

export { HEADER_HEIGHT, SIDEBAR_MINWIDTH, SIDEBAR_MAXWIDTH, MENUS };
